(() => {
  const init = () => {
    const controls = document.querySelector('.fs-gift-page [data-fs-gift-controls]');
    const form = document.querySelector('.fs-gift-page #MainContent .product-single__form');
    const button = form?.querySelector('[data-add-to-cart]');
    const label = button?.querySelector('[data-add-to-cart-text]');
    if (!controls || !form || !button || !label || controls.dataset.ready) return;
    controls.dataset.ready = 'true';
    const scope = form.closest('.product-section') || form;
    const recipientBindings = new WeakMap();
    const syncRecipients = () => {
      form.querySelectorAll('.recipient-form').forEach((recipient) => {
        const checkbox = recipient.querySelector('input[type="checkbox"]');
        const fields = recipient.querySelector('.recipient-fields');
        const email = fields?.querySelector('input[type="email"]');
        if (!checkbox || !fields || !email) return;
        let binding = recipientBindings.get(checkbox);
        if (!binding || binding.fields !== fields) {
          if (binding) checkbox.removeEventListener('change', binding.sync);
          const sync = () => {
            const enabled = checkbox.checked;
            if (!fields.id) fields.id = `${email.id}-fields`;
            checkbox.value = 'true';
            checkbox.setAttribute('aria-controls', fields.id);
            checkbox.setAttribute('aria-expanded', String(enabled));
            fields.hidden = !enabled;
            fields.style.display = enabled ? 'block' : 'none';
            fields.querySelectorAll('input, textarea, select').forEach((input) => { input.disabled = !enabled; });
            email.required = enabled;
          };
          binding = { fields, sync };
          recipientBindings.set(checkbox, binding);
          checkbox.addEventListener('change', sync);
        }
        binding.sync();
      });
    };
    new MutationObserver(syncRecipients).observe(form, { childList: true, subtree: true });
    window.addEventListener('pageshow', syncRecipients);
    syncRecipients();
    const idle = label.dataset.defaultText || label.textContent.trim();
    let editedWhileAdding = false;
    const check = document.createElement('span');
    check.className = 'fs-gift-button-check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    button.prepend(check);
    form.classList.add('fs-gift-feedback-ready');
    const reset = () => {
      delete button.dataset.fsGiftState;
      button.removeAttribute('aria-label');
      if (!button.disabled) label.textContent = idle;
    };
    const syncBusy = () => {
      if (button.getAttribute('aria-busy') === 'true' && button.dataset.fsGiftState !== 'added') {
        button.dataset.fsGiftState = 'adding';
        label.textContent = controls.dataset.adding;
      } else if (button.getAttribute('aria-busy') !== 'true' && button.dataset.fsGiftState === 'adding') {
        reset();
      }
    };
    new MutationObserver(syncBusy).observe(button, { attributes: true, attributeFilter: ['aria-busy'] });
    form.addEventListener('ajaxProduct:added', () => {
      form.querySelector('[data-cart-status] a')?.remove();
      if (editedWhileAdding) {
        reset();
        form.classList.remove('fs-gift-feedback-ready');
        return;
      }
      button.dataset.fsGiftState = 'added';
      label.textContent = `${controls.dataset.added} · ${controls.dataset.viewCart}`;
      button.setAttribute('aria-label', `${controls.dataset.added}. ${controls.dataset.viewCart}`);
    });
    form.addEventListener('ajaxProduct:error', reset);
    scope.addEventListener('input', (event) => {
      if (form.contains(event.target) || event.target.closest('.variant-input')) {
        if (button.getAttribute('aria-busy') === 'true') editedWhileAdding = true;
        else reset();
      }
    });
    scope.addEventListener('change', (event) => {
      if (form.contains(event.target) || event.target.closest('.variant-input')) {
        if (button.getAttribute('aria-busy') === 'true') editedWhileAdding = true;
        else reset();
      }
    });
    button.addEventListener('click', (event) => {
      if (button.dataset.fsGiftState !== 'added') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(controls.dataset.cartUrl);
    }, true);
    form.addEventListener('submit', (event) => {
      syncRecipients();
      if (button.dataset.fsGiftState === 'added') {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(controls.dataset.cartUrl);
      } else if (!form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.reportValidity();
      } else if (button.getAttribute('aria-busy') !== 'true') {
        editedWhileAdding = false;
        form.classList.add('fs-gift-feedback-ready');
      }
    }, true);
    const amount = controls.querySelector('[data-fs-gift-amount]');
    const request = controls.querySelector('[data-fs-gift-request]');
    const updateRequest = () => {
      const validAmount = amount.value && amount.validity.valid && Number.isFinite(amount.valueAsNumber);
      const value = validAmount ? `${amount.valueAsNumber.toFixed(2)} ${controls.dataset.currency}` : '';
      const body = controls.dataset.requestBody.replace('[amount]', value || '_____');
      request.href = `mailto:cs@franceandson.com?subject=${encodeURIComponent(controls.dataset.requestSubject)}&body=${encodeURIComponent(body)}`;
    };
    amount.addEventListener('input', updateRequest);
    request.addEventListener('click', (event) => {
      if (amount.value && !amount.reportValidity()) event.preventDefault();
      else updateRequest();
    });
    updateRequest();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
